import { render, staticRenderFns } from "./TagDisplay.vue?vue&type=template&id=8dfeba84&scoped=true&"
import script from "./TagDisplay.vue?vue&type=script&lang=js&"
export * from "./TagDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TagDisplay.vue?vue&type=style&index=0&id=8dfeba84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfeba84",
  null
  
)

export default component.exports